import type { Application } from './application'
import { buildApplicationFactories } from './application'
import type { CustomElement } from './element'
import { buildCustomElementFactories } from './element'
import type { Plugin } from './plugin'

export const createMSPA = (options: {
  customElements: CustomElement[]
  applications: Application[]
  plugins: Plugin[]
}) => {
  const factories = [
    ...buildApplicationFactories(options.applications, options.plugins),
    ...buildCustomElementFactories(options.customElements, options.plugins)
  ]

  return {
    run: () => Promise.all(factories.map((f) => f()))
  }
}
